/* src/app/component/flight-card/flight-card.component.scss */
@media screen and (max-width: 767px) {
  .hr-dashed-middle {
    margin: 20px 0 !important;
  }
  .stopOverText span {
    font-size: 12px;
    line-height: 18px;
  }
}
.stopOverText {
  margin-top: -0.8em;
  text-align: center;
}
.stopOverText span {
  background-color: white;
  padding-right: 10px;
  padding-left: 7px;
}
.stopOverText span span {
  background-color: white;
  padding-right: 2px;
  padding-left: 2px;
}
.hr-dashed-middle {
  margin: 20px 0 !important;
}
/*# sourceMappingURL=flight-card.component-FEHQFTWK.css.map */
